import PropTypes from 'prop-types';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLoading = ({
  message
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    minHeight: 100
  }), /*#__PURE__*/_jsx(Text, {
    as: "h1",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `login.loading.${message}`
    })
  })]
});
LoginLoading.propTypes = {
  message: PropTypes.string
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
LoginLoading.defaultProps = {
  message: 'default'
};
export default LoginLoading;